module.exports = [{
  code: 0,
  name: 'nr-handling-charge',
  title: 'Gestion commande non-récupérée',
  description: 'Nous sommes malheureusement obligés d\'appliquer une charge de gestion supplémentaire pour les commandes non-récupérées lors de la distribution', 
  amount: 300,
  amount_ht: 284,
  tva: 5.5
},{
  code: 1,
  name: 'private-locale-charge',
  title: 'Gestion commande local privé',
  description: '',
  amount: 250,
  amount_ht: 237,
  tva: 5.5
},{
  code: 2,
  name: 'home-delivery-charge',
  title: 'Frais livraison domicile',
  description: '',
  amount: 550,
  amount_ht: 522,
  tva: 5.5
}];